import React from 'react';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    & > div,
    * > span {
        width: ${(props) => (100 - 2) / props.numberOfItems}%;
        flex-shrink: 0;
    }
`;

const CustomGrid = ({ numberOfItems = 2, children }) => {
    return <SLayout numberOfItems={numberOfItems}>{children}</SLayout>;
};

export default CustomGrid;
